import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';
import { Button, Popover, Tabs } from 'antd';
import { ResponsiveTable } from '../../../common/components/data-display';
import { Form } from 'antd';
import { currencyFormatter, formatDate, percentageFormatter } from '../../utils/helpers';
import { Row, Col } from 'react-flexbox-grid';
import { miniStatusT } from '../../../common/enums'

const TabPane = Tabs.TabPane
const Column = Table.Column;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },

};

const renderDue = (date, days,state) => {
  
 
    if (days < 0){
      return {
        children: <span>{formatDate(date)}<br/>{state !== 'ZAMIETNUTÁ' && state !== 'ČAKÁ NA SCHVÁLENIE' ? <span style={{color: 'green'}} > DPD: {days}</span> : null} </span> ,
      };
    }
    else if (days > 0){
      return {
        children: <span>{formatDate(date)}<br/> {state !== 'ZAMIETNUTÁ' && state !== 'ČAKÁ NA SCHVÁLENIE' ? <span style={{color: 'red'}} > DPD: {days}</span> : null} </span> ,
      };
    }
    else {
      return {
        children: <span>{formatDate(date)}<br/>{state !== 'ZAMIETNUTÁ' && state !== 'ČAKÁ NA SCHVÁLENIE' ? <span > DPD: {days}</span> : null} </span> ,
      };
    }
};

const renderExtension = (amount, days, state) => {
  if (state !== 'ZAMIETNUTÁ' && state !== 'ČAKÁ NA SCHVÁLENIE'){
    return {
      children: <span>{amount != null ? currencyFormatter(amount): currencyFormatter(0)}<br/> {days >= 0 ? `${days} dní` : ''}</span> ,
    };
  }
    return {
      children: null
    }
};

const renderColor = (color) => {
  if (color === 'success') {
    return 'green'
  }
  else if (color === 'warning'){
    return 'orange'
  }
  else if (color === 'disabled')
    return 'gray'
  else if (color === 'danger' || color === 'error' || color === 'big-error'){
    return 'red'
  }
  else {
    return 'black'
  }
}

const renderAttributes = (physicalPaper, distraint, payrollDeduction, prosecution) => {
  let paper = physicalPaper ? 'Predžalobná úpomienka' : ''
  let dist = distraint ? 'Exekúcia' : ''
  let payroll = payrollDeduction ? 'Zrážka zo mzdy' : ''
  let prosec = prosecution ? 'Žaloba' : ''
  return {
    children: <span>
                {paper ? <React.Fragment><span>{paper}</span><br/> </React.Fragment>: null }
                { dist ? <React.Fragment><span>{dist}</span><br/> </React.Fragment>: null }
                { payroll ? <React.Fragment><span>{payroll}</span><br/> </React.Fragment>: null }
                { prosec ? <React.Fragment><span>{prosec}</span><br/> </React.Fragment>: null }
          </span> ,
  };
};



const MINIList = ({ data, token, t}) => {

  const isObject = (value) => typeof value === "object" && value === null

  if(isObject(data)){
    return(
      <span>Mini nedostupné v čase žiadosti</span>
    )
  }

  if( Object.keys(data).length !== 0 ){

    let years = data.notes.map(note => {
      let date = new Date(note.dateCreated)
      let year = date.getFullYear()
      return year
    })
  
    years = [...new Set(years)]
    years = years.sort((a,b) => b-a)
  
    let notesToWrite = years.map(year => '')
  
    let sortedNotes = data.notes.sort((a,b) => new Date(b.dateCreated) - new Date(a.dateCreated))
    sortedNotes.forEach(note => {
      let date = new Date(note.dateCreated)
      let year = date.getFullYear()
      for(let i = 0; i < years.length; i++){
        if(year === years[i]){
          notesToWrite[i] = notesToWrite[i] + formatDate(note.dateCreated) + ":  " + note.note + "\n"
        }
      }
    })

    let color = renderColor(data.color)
    return (
      // first we display general data, then show table with all loans from mini
      
      <section>
        <Row>
          <Col xs={14} sm={6}>
            <Form.Item {...formItemLayout} style={{marginBottom: 0+'px'}} label={t('Farba klienta v MINI')}>
              <span style={{marginBottom: 12+'px'}}>{`${data.firstName} ${data.lastName}`}</span>
            </Form.Item>
      
            <Form.Item {...formItemLayout} style={{marginBottom: 0+'px'}} label={t('Farba klienta v MINI')}>
              <span style={{color: color}}>{miniStatusT[data.color]}</span>
            </Form.Item>
      
            <Form.Item {...formItemLayout} style={{marginBottom: 0+'px'}} label={t('Stav klienta v MINI')}>
              <span>{`${data.state}`}</span>
            </Form.Item>

            {data.flags && < Form.Item {...formItemLayout} style={{marginBottom: 0+'px'}} label={t('Príznaky')}>  
              {data.flags.map(flag => {
                return <span>{`${flag.type}, ${flag.note}, ${formatDate(flag.dateCreated)} `} <br /></span>
              })}
            </Form.Item>}
          </Col>
          <Col xs={14} sm={6}>
              <h4>Počty pôžičiek klienta</h4>
              <Form.Item {...formItemLayout} style={{marginBottom:0+'px'}} label={t('Otvorené')}>
                <span>{`${data.loansCount.open}`}</span>
              </Form.Item>

              <Form.Item {...formItemLayout} style={{marginBottom:0+'px'}} label={t('Zamietnuté')}>
                <span>{`${data.loansCount.rejected}`}</span>
              </Form.Item>

              <Form.Item {...formItemLayout} style={{marginBottom:0+'px'}} label={t('Splatené v splatnosti')}>
                <span>{`${data.loansCount.paidInTime}`}</span>
              </Form.Item>

              <Form.Item {...formItemLayout} style={{marginBottom:0+'px'}} label={t('Splatené po splatnosti')}>
                <span>{`${data.loansCount.paidNotInTime}`}</span>
              </Form.Item>
            </Col>
        </Row>
        
        <div>
          <h4>Poznámky o klientovi</h4>
          <Tabs defaultActiveKey='1'>
            {
            years.map((year, index) => {
              return <TabPane tab={year} key={index+1}>{notesToWrite[index].split("\n").map((i) => {
                return <div style={{whiteSpace: 'pre'}}>{i}</div>
              })}</TabPane>
            })
            }
          </Tabs>
        </div>
        
        <br/>
  
        <ResponsiveTable dataSource={data.loans} rowkey={l => l.id} >
          <Column 
            title={t('Dátum žiadosti')}
            dataIndex="dateCreated"
            key="dateCreated"
            render={value => formatDate(value)}
          />

          <Column 
            title={t('Stav')}
            dataIndex="state"
            width={200}
            key="state"
            render={(value, record) => value === 'ZAMIETNUTÁ' || value === 'ZAMIETNUTÁ SOFTECOM' ? <span style={{color:'red'}}>{`${value}`} <br/> {`${record.rejectReason}`}</span> : value}
          />

          <Column 
            title={t('Dátum zamietnutia')}
            dataIndex="rejectDate"
            key="rejectDate"
            render={value => value ? formatDate(value) : ''}
          />

  
          <Column 
            title={t('Splatnosť')}
            dataIndex="dueDate"
            key="dueDate"
            render={(value,record) => renderDue(value, record.dueDateDates, record.state)}
          />

          <Column 
            title={t('Dátum splatenia')}
            dataIndex="repaymentDate"
            key="repaymentDate"
            render={value => value ? formatDate(value) : ''}
          />

          <Column 
            title={t('Istina')}
            dataIndex="amountLoaned"
            key="amountLoaned"
            render={value => currencyFormatter(value)}
          />
  
          <Column 
            title={t('Úrok')}
            dataIndex="fee"
            key="fee"
            render={value => currencyFormatter(value)}
          />

          <Column 
            title={t('Pokuty')}
            dataIndex="penalty"
            key="penalty"
            render={value => value != null ? currencyFormatter(value) : ''}
          />

          <Column 
            title={t('Súdne poplatky')}
            dataIndex="courtFee"
            key="courtFee"
            render={value => value != null ? currencyFormatter(value) : ''}
          />


          <Column 
            title={t('Predĺženia')}
            dataIndex="extensionsFee"
            key="extensionsFee"
            render={(value, record) => renderExtension(value, record.extensionDays, record.state) }
          />

          <Column 
            title={t('Dlžná suma')}
            dataIndex="amountToRepay"
            key="amountToRepay"
            render={value => value != null ? currencyFormatter(value) : ''}
          />

          <Column 
            title={t('Príznaky')}
            dataIndex="physicalPaper"
            key="physicalPaper"
            render={(value, record) => renderAttributes(value, record.distraint,record.payrollDeduction,record.prosecution)}
          />

          <Column 
            title={t('IP Adresa/Cookie')}
            dataIndex="ipaddress"
            key="ipaddress"
            render={((value,record) => <div>
               <Popover             
                content={
                  <div className='FixedHeightContainer'>
                    <div className='Content'>
                      {record.ipaddressList.sort((a,b) => new Date(b.dateCreated) - new Date(a.dateCreated)).map( val => {
                        let style = val.state === 'Zamietnutá' ? {color: 'red'} : null
                        return <div style={style}>
                       
                          <span>Dátum - {formatDate(val.dateCreated)}</span>
                          <br/>
                          <span>Meno - {val.client}</span>
                          <br/>
                          <span>Stav - {val.state}</span>
                          <br/><br/>
                    </div>
                      
                  })}  
                    </div>
                  </div>
                  
                }
                title="Žiadosti z danej IP adresy"
                trigger='click' 
                >
                <span style={{cursor: 'pointer'}}>IP: {record.ipaddressList.length} žiadosti</span>
              </Popover>
              <hr/>
              <Popover 
             
              content={
                <div className='FixedHeightContainer'>
                   <div className='Content'>
                    {record.infCookieList.sort((a,b) => new Date(b.dateCreated) - new Date(a.dateCreated)).map( val => {
                      let style = val.state === 'Zamietnutá' ? {color: 'red'} : null
                      return <div style={style}>
                      <span>Dátum - {formatDate(val.dateCreated)}</span>
                      <br/>
                      <span>Meno - {val.client}</span>
                      <br/>
                      <span>Stav - {val.state}</span>
                      <br/><br/>
                   </div>
                    
                })}  
                  </div>
                </div>
                
              }
              title="Žiadosti z danej cookie"
              trigger='click'
              >
                <span style={{cursor: 'pointer'}}> Cookie: {record.infCookieList.length} žiadosti </span>
              </Popover> 

            </div>
              )}
          />

          <Column 
            title={t('Údaje o príjme')}
            dataIndex="income"
            key="income"
            render={(value =>
              Object.keys(value).length > 0 ? <Popover 
              content={
                <div className='FixedHeightContainer'>
                  <div className='Content' >
                    
                      <span>Typ - {value.incomeType}</span>
                      <br/>

                      <span>Zamestnávateľ - {value.employer}</span>
                      <br/>
                    
                      <span>Príjmy - {value.salary}</span>
                      <br/>

                      <span>Výdaje - {value.expense}</span>
                      <br/>
                      <br/>
                      <span>Suma - {`${value.title}`}<span style={{color: value.color}}>={`${value.amount}`} </span><br/></span>
                      <br/>


                      <span>DSTI -  <span style={{color: value.dstiColor}}>{value.dsti}</span></span>
                      <br/>
                    
                  </div>     
                </div>
              }
                title="Údaje o príjme"
                trigger='click'
                placement='leftTop'
              >
                   <div>
                     <span style={{cursor: 'pointer'}}>{`${value.title}`}<br/><span style={{color: value.color}}>={`${value.amount}`} </span><br/></span> 
                  </div> 
              </Popover>
             : <span></span>
            )}
          />
          
  
        </ResponsiveTable>
  
  
      </section>
      
    )
  }
  else {
    return (
      <span>Klient bez pôžičky</span>
    )
  }
 
}



export default translate()(MINIList)


// WEBPACK FOOTER //
// ./src/common/components/data-display/MINIList.js